<template>
    <div>
        <section class="Subscription">
            <!-- <Topheader /> -->
            <div class="row" style=" padding-bottom: 25px;
    padding-left: 25px;
    padding-top: 25px;">
                           
                        </div>
            <div class="container">
                <div class="leftside">
                    <button class="backbutton" @click="$router.go(-1)">
                <img src="images/back.png" />

                    </button>



                </div>

                <div class="main-Subscription">
                    <div class="Subscription-box">

                        <div class="row transparetdivs" >
                            <div class="col-2 text-center">
                                <img src="/images/aboutus.png" alt="">
                                <br>
                                <h2 style="font-weight: bold;
    color: #9da8b0;">
                                    ABOUT US

                                </h2>

                            </div>

                            <div class="col-10">


                            <p>
                                What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines. What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                            </p>
                        </div>

                        </div>
                        <div class="row scale text-center" style="justify-content: center;">
                            <div class="col-3 text-center">



                                <div class="transparetdiv">
                                    <div class="imges">
                                    <svg width="60" height="58" viewBox="0 0 54 52" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.08532 8.91664L9.8147 12.4862L13.7242 13.0183C13.8955 13.0414 14.057 13.112 14.1901 13.2222C14.3233 13.3324 14.4229 13.4778 14.4775 13.6418C14.5322 13.8058 14.5398 13.9818 14.4993 14.1499C14.4589 14.3179 14.3722 14.4713 14.249 14.5925L11.3889 17.3343L12.1279 21.2291C12.1594 21.3999 12.1418 21.5761 12.077 21.7373C12.0123 21.8984 11.903 22.0378 11.7621 22.1393C11.6211 22.2408 11.4542 22.3001 11.2809 22.3103C11.1075 22.3206 10.9348 22.2814 10.7828 22.1972L7.265 20.3349L3.78409 22.212C3.62719 22.2968 3.44911 22.3343 3.27135 22.3201C3.09359 22.3059 2.92377 22.2406 2.78234 22.1319C2.6409 22.0233 2.5339 21.8761 2.4743 21.708C2.4147 21.5399 2.40502 21.3582 2.44642 21.1848L3.14112 17.3417L0.281034 14.5925C0.155224 14.4706 0.0666821 14.3155 0.0256797 14.1452C-0.0153227 13.9749 -0.00709882 13.7965 0.0494514 13.6307C0.106002 13.4649 0.208517 13.3187 0.345041 13.2089C0.481566 13.0992 0.646506 13.0305 0.820565 13.0109L4.72269 12.4788L6.44467 8.90927C6.51861 8.75437 6.63487 8.62357 6.78004 8.53201C6.92522 8.44045 7.09336 8.39186 7.265 8.39186C7.43663 8.39186 7.60477 8.44045 7.74995 8.53201C7.89512 8.62357 8.01138 8.75437 8.08532 8.90927V8.91664ZM8.36616 13.7352L7.265 11.4663L6.15643 13.7574C6.08717 13.8992 5.98303 14.021 5.85376 14.1115C5.72449 14.202 5.57432 14.2582 5.41739 14.2747L2.90463 14.6147L4.74488 16.3736C4.85423 16.4772 4.93585 16.6066 4.98233 16.7499C5.0288 16.8932 5.03864 17.0458 5.01092 17.1939L4.56012 19.6993L6.77725 18.502C6.91187 18.4276 7.06314 18.3886 7.21696 18.3886C7.37077 18.3886 7.52209 18.4276 7.65671 18.502L9.87384 19.7067L9.43038 17.253C9.39542 17.0965 9.40084 16.9337 9.44608 16.7799C9.49133 16.626 9.57495 16.4863 9.68908 16.3736L11.5293 14.6147L9.03872 14.2747C8.88179 14.2582 8.73162 14.202 8.60234 14.1115C8.47307 14.021 8.36893 13.8992 8.29967 13.7574L8.36616 13.7352ZM27.7956 0.521128L29.525 4.09069L33.4493 4.62281C33.6199 4.64853 33.7801 4.72119 33.9119 4.83267C34.0437 4.94414 34.1419 5.09006 34.1955 5.25411C34.2492 5.41816 34.2562 5.59388 34.2158 5.76168C34.1754 5.92948 34.0891 6.08275 33.9666 6.20437L31.1065 8.95361L31.8456 12.841C31.8757 13.0116 31.8572 13.1873 31.7923 13.348C31.7273 13.5086 31.6185 13.6478 31.4782 13.7495C31.3379 13.8513 31.1719 13.9115 30.999 13.9234C30.8261 13.9352 30.6533 13.8982 30.5005 13.8165L26.99 11.9393L23.5091 13.8165C23.3521 13.9035 23.173 13.9424 22.9941 13.9285C22.8152 13.9146 22.6442 13.8484 22.5026 13.7382C22.3609 13.628 22.2547 13.4786 22.1971 13.3086C22.1396 13.1386 22.1332 12.9554 22.1789 12.7818L22.8736 8.93881L19.9987 6.19697C19.8737 6.07466 19.7858 5.91966 19.7448 5.74968C19.7039 5.57971 19.7116 5.40163 19.7671 5.23584C19.8226 5.07005 19.9237 4.92326 20.0588 4.81223C20.1938 4.70121 20.3574 4.63043 20.5308 4.60803L24.4329 4.07592L26.1623 0.521128C26.238 0.36494 26.3561 0.233218 26.5031 0.141051C26.6502 0.0488849 26.8202 0 26.9937 0C27.1673 0 27.3373 0.0488849 27.4844 0.141051C27.6314 0.233218 27.7495 0.36494 27.8252 0.521128H27.7956ZM28.0764 5.33968L26.9605 3.04864L25.8593 5.33968C25.7934 5.47667 25.695 5.59545 25.5726 5.68563C25.4502 5.77581 25.3076 5.83465 25.1572 5.85702L22.6297 6.19697L24.4699 7.95589C24.58 8.05917 24.6627 8.18824 24.7104 8.33146C24.7581 8.47468 24.7695 8.62753 24.7434 8.77622L24.2852 11.2816L26.5023 10.0843C26.6373 10.0112 26.7885 9.97297 26.942 9.97297C27.0956 9.97297 27.2467 10.0112 27.3817 10.0843L29.5988 11.289L29.1628 8.83536C29.1248 8.67956 29.1279 8.51654 29.172 8.36234C29.216 8.20813 29.2995 8.06806 29.4141 7.95589L31.2543 6.19697L28.7638 5.84962C28.6155 5.82951 28.4747 5.7722 28.3545 5.68304C28.2343 5.59387 28.1387 5.47576 28.0764 5.33968ZM47.4911 8.91664L49.2205 12.4862L53.13 13.0183C53.3013 13.0414 53.4627 13.112 53.5959 13.2222C53.7291 13.3324 53.8286 13.4778 53.8833 13.6418C53.9379 13.8058 53.9455 13.9818 53.9051 14.1499C53.8647 14.3179 53.7779 14.4713 53.6547 14.5925L50.7946 17.3343L51.5337 21.2291C51.5641 21.3989 51.5461 21.5738 51.4816 21.7338C51.417 21.8937 51.3087 22.0323 51.169 22.1334C51.0292 22.2345 50.8638 22.2942 50.6916 22.3055C50.5195 22.3168 50.3477 22.2792 50.196 22.1972L46.6707 20.3349L43.1824 22.212C43.0256 22.2968 42.8475 22.3343 42.6698 22.3201C42.492 22.3059 42.3221 22.2406 42.1807 22.1319C42.0393 22.0233 41.9323 21.8761 41.8727 21.708C41.8131 21.5399 41.8034 21.3582 41.8448 21.1848L42.5395 17.3417L39.6794 14.5925C39.5538 14.4711 39.4652 14.3166 39.4238 14.1469C39.3825 13.9771 39.3901 13.7992 39.4458 13.6336C39.5015 13.468 39.603 13.3217 39.7385 13.2114C39.8741 13.1012 40.0381 13.0317 40.2115 13.0109L44.1136 12.4788L45.8356 8.90927C45.9121 8.75505 46.03 8.62526 46.1763 8.53451C46.3225 8.44377 46.4912 8.39567 46.6634 8.39567C46.8355 8.39567 47.0042 8.44377 47.1504 8.53451C47.2967 8.62526 47.4146 8.75505 47.4911 8.90927V8.91664ZM47.7719 13.7352L46.6707 11.4442L45.5622 13.7352C45.4929 13.877 45.3887 13.9989 45.2595 14.0894C45.1302 14.1798 44.9801 14.236 44.8231 14.2525L42.3104 14.5925L44.1432 16.3514C44.2494 16.4573 44.3289 16.5869 44.3752 16.7295C44.4214 16.8721 44.4331 17.0237 44.4093 17.1718L43.9511 19.6771L46.1682 18.4799C46.3028 18.4054 46.4541 18.3664 46.6079 18.3664C46.7617 18.3664 46.9131 18.4054 47.0477 18.4799L49.2648 19.6845L48.8213 17.2309C48.7864 17.0744 48.7918 16.9116 48.837 16.7577C48.8823 16.6039 48.9659 16.4641 49.08 16.3514L50.9054 14.5925L48.4223 14.2525C48.2653 14.236 48.1152 14.1798 47.9859 14.0894C47.8566 13.9989 47.7525 13.877 47.6832 13.7352H47.7719ZM22.6445 32.5586C22.5388 32.3481 22.5174 32.1052 22.5849 31.8795C22.6523 31.6539 22.8034 31.4625 23.0073 31.3445C23.2112 31.2265 23.4524 31.1909 23.6817 31.2448C23.9109 31.2988 24.1109 31.4383 24.2408 31.6348L25.4602 33.7411L29.8058 29.4251C29.9793 29.2516 30.2145 29.1542 30.4599 29.1542C30.7052 29.1542 30.9404 29.2516 31.1139 29.4251C31.2874 29.5985 31.3848 29.8338 31.3848 30.0791C31.3848 30.3244 31.2874 30.5597 31.1139 30.7332L25.9406 35.9065C25.8418 36.0134 25.7188 36.0952 25.5821 36.1451C25.4453 36.1951 25.2986 36.2117 25.1541 36.1936C25.0096 36.1756 24.8715 36.1233 24.7513 36.0413C24.631 35.9592 24.532 35.8497 24.4625 35.7217L22.6445 32.5586ZM26.9383 22.7811C28.7441 22.7796 30.5098 23.3139 32.0119 24.3162C33.514 25.3186 34.685 26.7439 35.3767 28.412C36.0684 30.0801 36.2498 31.9159 35.8978 33.6871C35.5459 35.4583 34.6765 37.0852 33.3996 38.3621C32.1227 39.639 30.4957 40.5085 28.7245 40.8604C26.9533 41.2124 25.1175 41.031 23.4495 40.3393C21.7814 39.6475 20.356 38.4765 19.3536 36.9744C18.3513 35.4723 17.8171 33.7067 17.8185 31.9009C17.8205 29.4828 18.7819 27.1642 20.4918 25.4544C22.2017 23.7445 24.5202 22.783 26.9383 22.7811ZM32.1116 26.7645C31.0948 25.7469 29.799 25.0537 28.3882 24.7726C26.9774 24.4915 25.5149 24.6351 24.1857 25.1854C22.8565 25.7356 21.7204 26.6677 20.921 27.8637C20.1217 29.0598 19.6951 30.466 19.6951 31.9046C19.6951 33.3431 20.1217 34.7494 20.921 35.9454C21.7204 37.1415 22.8565 38.0735 24.1857 38.6238C25.5149 39.174 26.9774 39.3177 28.3882 39.0366C29.799 38.7555 31.0948 38.0622 32.1116 37.0446C33.4741 35.681 34.2394 33.8322 34.2394 31.9046C34.2394 29.9769 33.4741 28.1282 32.1116 26.7645ZM26.9383 17.0461C29.6458 17.038 32.304 17.7704 34.6253 19.164C36.9466 20.5577 38.8426 22.5595 40.1082 24.953C41.3739 27.3465 41.9609 30.0405 41.8059 32.7436C41.6508 35.4467 40.7596 38.0559 39.2286 40.289L43.6628 47.9677C43.76 48.1183 43.8113 48.2939 43.8104 48.4732C43.8095 48.6525 43.7565 48.8276 43.6577 48.9772C43.559 49.1269 43.4189 49.2445 43.2544 49.3159C43.09 49.3873 42.9084 49.4093 42.7316 49.3792L38.1939 48.6402L35.7625 51.5964C35.6721 51.72 35.5522 51.8191 35.4137 51.8845C35.2753 51.9498 35.1226 51.9795 34.9697 51.9707C34.8168 51.9618 34.6686 51.9148 34.5385 51.834C34.4085 51.7531 34.3008 51.6409 34.2253 51.5077L31.1213 46.1348C28.4052 46.9181 25.5231 46.9181 22.8071 46.1348L19.7031 51.5077C19.6276 51.6409 19.5199 51.7531 19.3898 51.834C19.2598 51.9148 19.1115 51.9618 18.9586 51.9707C18.8057 51.9795 18.6531 51.9498 18.5146 51.8845C18.3761 51.8191 18.2562 51.72 18.1659 51.5964L15.7344 48.6402L11.1893 49.3792C11.0176 49.4039 10.8424 49.3801 10.6835 49.3105C10.5246 49.2409 10.3882 49.1283 10.2899 48.9854C10.1915 48.8425 10.1351 48.6749 10.1268 48.5016C10.1186 48.3283 10.159 48.1562 10.2434 48.0046L14.6776 40.289C13.1561 38.0582 12.2718 35.4548 12.1198 32.7588C11.9678 30.0629 12.5539 27.3765 13.815 24.9888C15.0761 22.6012 16.9644 20.6026 19.2768 19.2083C21.5892 17.814 24.2381 17.0766 26.9383 17.0757V17.0461ZM37.9722 41.8262C36.5525 43.4108 34.8083 44.6711 32.858 45.5214L35.1269 49.4458L37.0706 47.0586C37.1727 46.9283 37.309 46.8289 37.4643 46.7715C37.6196 46.7141 37.7877 46.7009 37.9501 46.7335L41.0762 47.236L37.9722 41.8262ZM20.9742 45.5214C19.0286 44.6668 17.2876 43.407 15.8675 41.8262L12.8078 47.236L15.934 46.7335C16.0962 46.7058 16.2629 46.7213 16.4172 46.7784C16.5716 46.8354 16.7082 46.9321 16.8134 47.0586L18.7571 49.4458L20.9742 45.5214ZM36.0951 22.7072C34.2777 20.891 31.9627 19.6545 29.4426 19.1538C26.9226 18.6532 24.3107 18.911 21.9371 19.8946C19.5636 20.8782 17.535 22.5435 16.1077 24.6799C14.6805 26.8163 13.9187 29.3279 13.9187 31.8972C13.9187 34.4665 14.6805 36.9781 16.1077 39.1145C17.535 41.2509 19.5636 42.9161 21.9371 43.8998C24.3107 44.8834 26.9226 45.1411 29.4426 44.6405C31.9627 44.1399 34.2777 42.9033 36.0951 41.0872C38.5316 38.6494 39.9004 35.3438 39.9004 31.8972C39.9004 28.4505 38.5316 25.1449 36.0951 22.7072Z"
                                    fill="#95A1A9" />
                            </svg>
                            <br>
                            <br>

                            <p>

                                AREA OF EXPERTISE
                            </p>


                                </div>
                                    <div class="innerdiv">
                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>




                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>





                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>

                                </div>



                                </div>
                            </div>

                            <div class="col-3 text-center">

                                <div class="transparetdiv" >

                                    <div class="imges">
                                        <svg width="49" height="49" viewBox="0 0 49 49" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_860_549)">
                                    <path
                                        d="M37.6559 25.835C37.3437 28.8598 36.0026 31.686 33.8564 33.8417C31.7103 35.9974 28.8891 37.3521 25.8639 37.6796C25.8038 37.6788 25.7442 37.6898 25.6883 37.712C25.6325 37.7343 25.5817 37.7673 25.5386 37.8092C25.4956 37.8511 25.4613 37.9011 25.4376 37.9563C25.414 38.0115 25.4014 38.0708 25.4007 38.1308V48.0284C25.4008 48.1498 25.3771 48.27 25.3307 48.3822C25.2843 48.4944 25.2162 48.5963 25.1304 48.6822C25.0446 48.7681 24.9426 48.8362 24.8304 48.8827C24.7182 48.9292 24.598 48.9531 24.4765 48.9531C24.355 48.9531 24.2347 48.9292 24.1225 48.8827C24.0103 48.8362 23.9084 48.7681 23.8226 48.6822C23.7368 48.5963 23.6687 48.4944 23.6223 48.3822C23.5759 48.27 23.5521 48.1498 23.5522 48.0284V44.4412C23.5431 44.3215 23.4914 44.2091 23.4064 44.1244C23.3214 44.0396 23.2088 43.9882 23.0891 43.9794C18.9759 43.6463 15.0746 42.0176 11.9468 39.3276C8.819 36.6376 6.62604 33.0252 5.68359 29.0103C5.64918 28.8939 5.63803 28.7718 5.65086 28.651C5.66368 28.5302 5.70023 28.4131 5.75834 28.3065C5.81644 28.1998 5.895 28.1056 5.98953 28.0293C6.08407 27.953 6.19271 27.896 6.30927 27.8617C6.54453 27.7925 6.79765 27.8196 7.01297 27.9368C7.2283 28.0541 7.38824 28.2519 7.45768 28.487C7.46405 28.5075 7.46935 28.5276 7.4736 28.5475C8.31081 32.1513 10.2652 35.399 13.0582 37.8275C15.8511 40.256 19.34 41.7413 23.0274 42.0716C23.1475 42.1311 23.2611 42.0716 23.3759 41.9569C23.4362 41.923 23.4851 41.8718 23.5161 41.81C23.5472 41.7481 23.559 41.6784 23.5501 41.6098V38.1414C23.5512 38.0205 23.5044 37.9039 23.4197 37.8174C23.3351 37.7308 23.2197 37.6813 23.0986 37.6796H23.0869C20.0763 37.3439 17.2669 36.0034 15.113 33.8748C12.9601 31.7117 11.616 28.8753 11.3055 25.8403C11.2878 25.7293 11.232 25.6279 11.1477 25.5535C11.0634 25.4792 10.9558 25.4364 10.8434 25.4326H0.949764C0.696188 25.4326 0.452965 25.332 0.27366 25.1528C0.0943538 24.9736 -0.00634766 24.7306 -0.00634766 24.4772C-0.00634766 24.2238 0.0943538 23.9807 0.27366 23.8016C0.452965 23.6224 0.696188 23.5217 0.949764 23.5217H4.70834C4.82044 23.5169 4.92751 23.4738 5.01163 23.3996C5.09575 23.3254 5.15183 23.2246 5.17047 23.114C5.41743 19.0103 6.94338 15.0866 9.53439 11.8932C12.1254 8.69986 15.6516 6.39691 19.6184 5.30727C19.7419 5.28375 19.8689 5.28481 19.992 5.31041C20.1152 5.336 20.2321 5.38563 20.336 5.45643C20.4399 5.52724 20.5288 5.61786 20.5976 5.72306C20.6665 5.82827 20.7138 5.94599 20.737 6.06952C20.781 6.30027 20.7383 6.53911 20.6172 6.74042C20.4961 6.94174 20.305 7.09142 20.0805 7.16088C16.5306 8.11798 13.3686 10.1593 11.0362 12.9997C8.70378 15.84 7.31747 19.3376 7.07097 23.0036C7.04527 23.1185 7.0662 23.2388 7.12912 23.3383C7.19204 23.4378 7.29184 23.5083 7.40669 23.5344C7.44813 23.5438 7.49067 23.5474 7.5331 23.5451H10.8264C10.9388 23.5415 11.0466 23.4988 11.1309 23.4244C11.2153 23.35 11.271 23.2485 11.2885 23.1374C11.5964 20.1071 12.9371 17.2746 15.0858 15.1144C17.2345 12.9542 20.0608 11.5974 23.0912 11.2715C23.2124 11.2729 23.3293 11.2262 23.4161 11.1416C23.503 11.0571 23.5527 10.9415 23.5544 10.8203V0.921662C23.5544 0.676703 23.6518 0.441773 23.8251 0.268561C23.9984 0.0953486 24.2335 -0.00195312 24.4786 -0.00195312C24.7237 -0.00195312 24.9588 0.0953486 25.1322 0.268561C25.3055 0.441773 25.4028 0.676703 25.4028 0.921662V12.1357C25.4147 12.3847 25.3271 12.6282 25.1594 12.8127C24.9917 12.9973 24.7575 13.1077 24.5083 13.1198C24.4786 13.1198 24.4489 13.1198 24.4191 13.1198C14.3619 13.1198 9.33379 25.4252 16.4451 32.535C23.5565 39.6447 35.6885 34.5574 35.8627 24.474C35.8613 24.3541 35.8835 24.2351 35.9282 24.1238C35.9728 24.0125 36.0389 23.911 36.1228 23.8253C36.2066 23.7395 36.3066 23.6711 36.4169 23.6239C36.5272 23.5767 36.6457 23.5518 36.7657 23.5504H48.0032C48.2568 23.5504 48.5 23.651 48.6793 23.8302C48.8586 24.0094 48.9593 24.2524 48.9593 24.5058C48.9593 24.7593 48.8586 25.0023 48.6793 25.1814C48.5 25.3606 48.2568 25.4613 48.0032 25.4613H44.3041C44.1894 25.4568 44.0774 25.4966 43.9913 25.5726C43.9052 25.6485 43.8517 25.7547 43.842 25.869C43.5423 29.9984 41.9444 33.9275 39.2766 37.0951C36.6088 40.2628 33.0076 42.5069 28.9872 43.5069C27.7751 43.7957 27.3554 41.9474 28.5792 41.6597C32.1693 40.7673 35.3887 38.7718 37.7839 35.9544C40.1792 33.137 41.6296 29.6396 41.9308 25.955C41.956 25.8401 41.9348 25.7201 41.872 25.6207C41.8092 25.5214 41.7097 25.4507 41.5951 25.4241C41.5536 25.4151 41.5111 25.4119 41.4687 25.4146H38.1181C38.0056 25.4182 37.8979 25.4608 37.8135 25.5353C37.7292 25.6097 37.6735 25.7112 37.6559 25.8223V25.835ZM45.1455 10.4636L38.4612 17.1062C38.2974 17.2828 38.0708 17.388 37.8302 17.3993H33.3747C33.2532 17.4099 33.136 17.4492 33.0326 17.5139L25.1128 25.4879C25.0225 25.5722 24.9165 25.638 24.8007 25.6814C24.685 25.7247 24.5619 25.7449 24.4383 25.7407C24.3148 25.7364 24.1933 25.7079 24.0808 25.6567C23.9683 25.6054 23.867 25.5326 23.7828 25.4422C23.6207 25.2681 23.5307 25.0392 23.5307 24.8015C23.5307 24.5638 23.6207 24.3349 23.7828 24.1608L31.7015 16.1816C31.7545 16.1546 31.7989 16.1134 31.8297 16.0626C31.8605 16.0117 31.8764 15.9533 31.8757 15.8939V11.435C31.875 11.3065 31.9002 11.1791 31.9498 11.0605C31.9995 10.942 32.0725 10.8346 32.1647 10.745L38.8107 4.10869C38.8946 4.01787 38.9955 3.94448 39.1078 3.8927C39.22 3.84093 39.3414 3.8118 39.4649 3.80696C39.5885 3.80213 39.7118 3.82171 39.8278 3.86456C39.9437 3.9074 40.0501 3.97268 40.1408 4.05667C40.2359 4.14431 40.3118 4.25069 40.3637 4.36909C40.4156 4.48749 40.4424 4.61533 40.4425 4.7446V8.38601C40.4502 8.50594 40.5014 8.61897 40.5865 8.70395C40.6715 8.78894 40.7846 8.84008 40.9046 8.84783H44.4868C44.739 8.84211 44.9832 8.93619 45.1663 9.10958C45.3493 9.28298 45.4564 9.52163 45.4642 9.77357C45.4674 9.90436 45.4437 10.0344 45.3945 10.1557C45.3454 10.2769 45.2718 10.3868 45.1784 10.4785L45.1455 10.4636ZM37.5306 15.3556L41.4028 11.486C41.4941 11.4018 41.5482 11.2848 41.5532 11.1608C41.5581 11.0367 41.5136 10.9158 41.4294 10.8246C41.3465 10.7355 41.2322 10.6823 41.1107 10.676H39.479C39.2262 10.6817 38.9814 10.588 38.7971 10.415C38.6129 10.2421 38.5041 10.0037 38.4942 9.75128V8.16943C38.4939 8.10669 38.4812 8.04463 38.4569 7.98678C38.4327 7.92893 38.3972 7.87642 38.3526 7.83225C38.308 7.78809 38.2552 7.75313 38.1971 7.72938C38.139 7.70563 38.0768 7.69354 38.014 7.69382C37.8908 7.69482 37.7727 7.74265 37.6836 7.82759L33.8761 11.6972C33.7749 11.7861 33.7127 11.9112 33.703 12.0455V15.0509C33.7021 15.1109 33.7131 15.1705 33.7354 15.2262C33.7577 15.2819 33.7907 15.3327 33.8327 15.3756C33.8746 15.4185 33.9247 15.4527 33.9799 15.4763C34.0351 15.4998 34.0945 15.5122 34.1545 15.5127H37.2268C37.3468 15.5127 37.4615 15.5127 37.5157 15.3938L37.5306 15.3556ZM32.3251 24.4857C32.3274 26.5685 31.5018 28.567 30.0301 30.0417C28.5583 31.5165 26.5607 32.3469 24.4765 32.3502C22.3921 32.3528 20.392 31.5279 18.916 30.0571C17.44 28.5863 16.6089 26.5899 16.6055 24.5069C16.603 22.4237 17.4285 20.4248 18.9006 18.9498C20.3726 17.4747 22.3706 16.6444 24.4552 16.6413H24.4712C24.7171 16.6602 24.9454 16.776 25.106 16.9631C25.2665 17.1503 25.3462 17.3934 25.3274 17.6392C25.3105 17.8605 25.2149 18.0685 25.0578 18.2255C24.9008 18.3824 24.6926 18.478 24.4712 18.4949C22.8844 18.4951 21.3627 19.1252 20.2407 20.2464C19.1188 21.3677 18.4883 22.8883 18.488 24.474C18.488 26.0597 19.1184 27.5806 20.2404 28.7019C21.3625 29.8232 22.8843 30.4531 24.4712 30.4531C27.9418 30.4531 30.2535 27.8553 30.4203 24.474C30.415 24.3485 30.4346 24.2232 30.4778 24.1052C30.5211 23.9873 30.5871 23.879 30.6723 23.7866C30.7574 23.6942 30.86 23.6195 30.9741 23.5668C31.0882 23.514 31.2115 23.4843 31.3371 23.4792C31.4628 23.4738 31.5883 23.4933 31.7064 23.5364C31.8246 23.5796 31.9331 23.6456 32.0256 23.7307C32.1182 23.8158 32.193 23.9183 32.2459 24.0324C32.2987 24.1465 32.3286 24.2698 32.3336 24.3954C32.3373 24.4399 32.3373 24.4847 32.3336 24.5292L32.3251 24.4857Z"
                                        fill="#95A1A9" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_860_549">
                                        <rect width="48.9529" height="48.9529" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <br>
                            <br>

                            <p>

                                VISION
                            </p>


                                </div>

                                    <div class="innerdiv">
                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>




                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>





                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>

                                </div>



                                </div>
                            </div>

                            <div class="col-3 text-center">

                                <div  class="transparetdiv">

                                    <div class="imges">
                                        <svg width="55" height="55" viewBox="0 0 55 55" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_860_868)">
                                    <path
                                        d="M15.2745 44.5939V41.8432L10.3988 39.1141V47.2044C10.4002 47.3011 10.3822 47.3972 10.3459 47.4868C10.3095 47.5765 10.2556 47.6579 10.1872 47.7263C10.1187 47.7947 10.0373 47.8487 9.94765 47.885C9.858 47.9214 9.76196 47.9394 9.66523 47.9379C9.568 47.9393 9.47146 47.9214 9.38121 47.8852C9.29097 47.849 9.20883 47.7952 9.13957 47.7269C9.07031 47.6587 9.01531 47.5773 8.97777 47.4876C8.94024 47.3979 8.92091 47.3016 8.92093 47.2044V37.852C8.92072 37.723 8.95451 37.5963 9.0189 37.4846C9.08329 37.3728 9.176 37.28 9.28769 37.2155C9.39844 37.149 9.52523 37.1138 9.65445 37.1138C9.78367 37.1138 9.91045 37.149 10.0212 37.2155L16.3748 40.7753C16.4886 40.841 16.5833 40.9353 16.6495 41.0488C16.7157 41.1623 16.7512 41.2911 16.7524 41.4225V44.6047C16.7524 44.702 16.733 44.7982 16.6955 44.8879C16.658 44.9776 16.603 45.059 16.5337 45.1272C16.4644 45.1955 16.3823 45.2493 16.2921 45.2855C16.2018 45.3217 16.1053 45.3397 16.008 45.3382C15.9113 45.3397 15.8153 45.3217 15.7256 45.2854C15.636 45.249 15.5545 45.195 15.4861 45.1266C15.4177 45.0582 15.3637 44.9768 15.3274 44.8871C15.291 44.7975 15.2731 44.7014 15.2745 44.6047V44.5939ZM1.63964 37.0429V28.2083C1.63964 25.6949 4.13146 24.5731 6.59091 24.5731H7.20578C6.67753 24.047 6.2617 23.4191 5.98355 22.7274C5.7054 22.0358 5.57073 21.2948 5.58771 20.5495C5.53513 20.0102 5.60026 19.4659 5.77861 18.9542C5.95697 18.4425 6.24429 17.9757 6.62073 17.5859C6.99716 17.1961 7.45373 16.8927 7.95889 16.6967C8.46406 16.5006 9.00576 16.4166 9.54658 16.4504C10.0883 16.415 10.6312 16.4978 11.1377 16.6931C11.6442 16.8884 12.1021 17.1916 12.4797 17.5815C12.8574 17.9715 13.1457 18.4389 13.3247 18.9514C13.5036 19.4639 13.569 20.0092 13.5162 20.5495C13.5312 21.2955 13.3945 22.0367 13.1145 22.7284C12.8345 23.42 12.4171 24.0476 11.8874 24.5731H17.7016C17.922 24.575 18.141 24.5384 18.3488 24.4652L21.1211 23.5267L22.9873 22.8687L27.0324 21.4448C27.3734 21.3271 27.6756 21.1182 27.9062 20.8407L29.2007 19.2874C30.6677 17.5399 31.8219 16.1699 33.9901 16.1699H35.9318C35.3136 15.6378 34.8223 14.9742 34.4938 14.2276C34.1653 13.481 34.0079 12.6704 34.0333 11.8551C33.9797 11.3093 34.0446 10.7584 34.2237 10.24C34.4027 9.7216 34.6916 9.24797 35.0706 8.85157C35.4496 8.45516 35.9097 8.1453 36.4195 7.94318C36.9294 7.74106 37.4768 7.65145 38.0245 7.68048C38.5761 7.64518 39.1288 7.73004 39.6443 7.92919C40.1599 8.12835 40.6261 8.43705 41.0108 8.83399C41.3954 9.23092 41.6893 9.70663 41.8721 10.2282C42.0549 10.7498 42.1223 11.3049 42.0697 11.8551C42.0911 12.6542 41.9382 13.4484 41.6215 14.1824C41.3048 14.9164 40.8319 15.5726 40.2359 16.1052H44.7341V11.7364C44.7361 11.1765 44.9267 10.6336 45.275 10.1952C45.6233 9.75688 46.1092 9.44861 46.6542 9.32014V0.744392C46.6527 0.64716 46.6707 0.550605 46.7069 0.460362C46.7431 0.370118 46.7969 0.287992 46.8652 0.218732C46.9334 0.149471 47.0148 0.0944677 47.1045 0.0569321C47.1942 0.0193964 47.2905 6.94345e-05 47.3877 7.995e-05H54.0865C54.2141 -0.00180385 54.3399 0.0296317 54.4516 0.0912672C54.5634 0.152903 54.6571 0.242602 54.7235 0.35153C54.79 0.460457 54.8268 0.584853 54.8305 0.712394C54.8342 0.839935 54.8045 0.966214 54.7445 1.07879L53.9678 2.57821L54.7445 4.0776C54.8059 4.18815 54.8381 4.31251 54.8381 4.43896C54.8381 4.56541 54.8059 4.6898 54.7445 4.80035C54.6779 4.9093 54.5843 4.99926 54.4729 5.0616C54.3614 5.12394 54.2358 5.15656 54.1081 5.15631H48.132V9.34171C48.6406 9.50367 49.0848 9.82271 49.4008 10.253C49.7167 10.6833 49.8881 11.2026 49.8903 11.7364V18.6186C49.8874 19.2948 49.6168 19.9423 49.1377 20.4194C48.6586 20.8965 48.0099 21.1644 47.3338 21.1643L44.2379 21.283C43.9496 21.2799 43.6636 21.3347 43.3968 21.444C43.13 21.5533 42.8878 21.715 42.6845 21.9195C42.2794 22.3222 42.0505 22.8692 42.0481 23.4404V28.3809L48.1967 31.9299C48.3093 31.9961 48.4024 32.0908 48.4668 32.2044C48.5311 32.318 48.5645 32.4465 48.5635 32.5771V38.7689C48.5635 38.9663 48.4851 39.1556 48.3455 39.2952C48.2059 39.4348 48.0166 39.5132 47.8192 39.5132C47.7219 39.5132 47.6257 39.4939 47.536 39.4563C47.4462 39.4188 47.3649 39.3638 47.2966 39.2945C47.2284 39.2253 47.1746 39.1432 47.1384 39.0529C47.1021 38.9627 47.0842 38.8661 47.0857 38.7689V32.987L40.937 29.4381C40.8253 29.3736 40.7326 29.2808 40.6682 29.169C40.6038 29.0573 40.57 28.9306 40.5703 28.8016V23.4081C40.5731 22.4448 40.957 21.5218 41.6381 20.8407C42.3193 20.1596 43.2422 19.7757 44.2055 19.7728L47.3122 19.6542C47.5983 19.6542 47.8727 19.5405 48.0749 19.3382C48.2772 19.1359 48.3909 18.8615 48.3909 18.5755V11.7364C48.3909 11.4503 48.2772 11.176 48.0749 10.9737C47.8727 10.7714 47.5983 10.6577 47.3122 10.6577C47.0261 10.6577 46.7517 10.7714 46.5494 10.9737C46.3471 11.176 46.2335 11.4503 46.2335 11.7364V16.267C46.2307 16.6362 46.0835 16.9897 45.8235 17.2518C45.5634 17.5138 45.2111 17.6637 44.8419 17.6693H33.9901C32.577 17.6693 31.8327 18.5107 30.3441 20.2582L29.0388 21.8008C28.6457 22.2939 28.1227 22.6675 27.5287 22.8795L24.8103 23.8288C25.0265 24.0495 25.1986 24.3094 25.3173 24.5947C25.4804 24.9941 25.5398 25.4282 25.4899 25.8567L29.3948 24.681C29.745 24.5802 30.0593 24.3819 30.3009 24.1092L32.3613 21.8224C32.4584 21.7088 32.5883 21.628 32.7332 21.5913C32.8781 21.5546 33.0308 21.5637 33.1703 21.6174C33.3113 21.6722 33.4322 21.7687 33.517 21.8939C33.6018 22.0192 33.6464 22.1673 33.6449 22.3186V41.6814C33.6464 41.7786 33.6284 41.8752 33.5922 41.9654C33.556 42.0557 33.5022 42.1378 33.4339 42.2071C33.3657 42.2763 33.2843 42.3313 33.1946 42.3689C33.1049 42.4064 33.0087 42.4257 32.9114 42.4257C32.714 42.4257 32.5247 42.3473 32.3851 42.2077C32.2455 42.0681 32.1671 41.8788 32.1671 41.6814V24.1955L31.4012 25.0369C30.9844 25.519 30.4377 25.8709 29.8263 26.0509L23.9042 27.9171L19.6864 29.3733C19.3061 29.5111 18.9044 29.5805 18.4999 29.5783H16.4503C16.1787 29.5775 15.9097 29.6315 15.6594 29.7371C15.4092 29.8428 15.1829 29.9979 14.9941 30.1931C14.7995 30.3847 14.6449 30.6131 14.5393 30.865C14.4338 31.1168 14.3793 31.3871 14.3792 31.6602V35.468L20.366 38.9415C20.4805 39.0037 20.576 39.0957 20.6424 39.2077C20.7089 39.3197 20.7438 39.4477 20.7436 39.5779V44.6371C20.7436 44.7343 20.7243 44.8306 20.6867 44.9203C20.6492 45.01 20.5942 45.0913 20.5249 45.1596C20.4557 45.2279 20.3735 45.2817 20.2833 45.3179C20.193 45.3541 20.0965 45.372 19.9993 45.3706C19.902 45.372 19.8055 45.3541 19.7152 45.3179C19.625 45.2817 19.5429 45.2279 19.4736 45.1596C19.4043 45.0913 19.3493 45.01 19.3118 44.9203C19.2743 44.8306 19.2549 44.7343 19.255 44.6371V40.0094L13.3113 36.5467C13.1968 36.4845 13.1013 36.3926 13.0349 36.2805C12.9684 36.1685 12.9335 36.0406 12.9337 35.9103V31.7141C12.9466 30.7666 13.3345 29.8628 14.0124 29.2007C14.3388 28.8631 14.7292 28.5939 15.1607 28.4087C15.5922 28.2235 16.0563 28.1261 16.5258 28.122H18.5214C18.7535 28.1266 18.9843 28.0863 19.201 28.0034L23.5159 26.4824C23.7509 26.3751 23.936 26.1822 24.0336 25.9431C24.1329 25.6899 24.1329 25.4087 24.0336 25.1556C23.9184 24.9145 23.7178 24.7248 23.4707 24.6231C23.2236 24.5215 22.9475 24.5152 22.696 24.6054L18.8235 25.8675C18.4766 25.9881 18.112 26.05 17.7448 26.0509H6.63406C6.27809 26.0509 3.17141 26.1156 3.17141 28.2083V37.0429C3.17834 37.5042 3.33293 37.9511 3.6125 38.318C3.89207 38.685 4.28188 38.9526 4.72475 39.0817V29.3194C4.72329 29.2227 4.74127 29.1266 4.77762 29.037C4.81397 28.9473 4.86794 28.8659 4.93635 28.7975C5.00475 28.7291 5.0862 28.6751 5.17585 28.6387C5.2655 28.6024 5.36154 28.5844 5.45827 28.5859C5.5555 28.5844 5.65204 28.6024 5.74229 28.6386C5.83253 28.6748 5.91467 28.7286 5.98393 28.7969C6.05319 28.8651 6.10819 28.9465 6.14573 29.0362C6.18326 29.1259 6.20259 29.2221 6.20258 29.3194V39.9447V47.1936C6.20259 47.2908 6.18326 47.3871 6.14573 47.4768C6.10819 47.5665 6.05319 47.6479 5.98393 47.7161C5.91467 47.7844 5.83253 47.8382 5.74229 47.8744C5.65204 47.9106 5.5555 47.9285 5.45827 47.9271C5.36154 47.9286 5.2655 47.9106 5.17585 47.8742C5.0862 47.8379 5.00475 47.7839 4.93635 47.7155C4.86794 47.6471 4.81397 47.5657 4.77762 47.476C4.74127 47.3864 4.72329 47.2903 4.72475 47.1936V40.6027C3.88048 40.4566 3.11401 40.0195 2.55835 39.3673C2.00269 38.7151 1.69292 37.8889 1.68279 37.0322L1.63964 37.0429ZM48.132 3.67848H52.8675L52.4684 2.92337C52.4152 2.81609 52.3875 2.69797 52.3875 2.57821C52.3875 2.45845 52.4152 2.3403 52.4684 2.23302L52.8675 1.47791H48.132V3.67848ZM35.5111 11.8551C35.5111 13.8399 36.6653 15.458 38.0676 15.458C39.47 15.458 40.6242 13.8399 40.6242 11.8551C40.6743 11.5014 40.6438 11.141 40.5352 10.8007C40.4265 10.4604 40.2425 10.149 39.9967 9.88975C39.7509 9.63051 39.4498 9.4301 39.1158 9.30345C38.7818 9.17681 38.4235 9.12718 38.0676 9.15831C37.7118 9.12718 37.3535 9.17681 37.0195 9.30345C36.6855 9.4301 36.3843 9.63051 36.1386 9.88975C35.8928 10.149 35.7087 10.4604 35.6001 10.8007C35.4915 11.141 35.461 11.5014 35.5111 11.8551ZM7.06555 20.5495C7.06555 22.4804 8.14425 24.0553 9.54658 24.0553C10.9489 24.0553 12.0276 22.4804 12.0276 20.5495C12.0758 20.2061 12.0461 19.8563 11.9406 19.526C11.8351 19.1957 11.6565 18.8934 11.4181 18.6416C11.1798 18.3897 10.8878 18.1948 10.5638 18.0714C10.2397 17.9479 9.89208 17.8989 9.54658 17.9282C9.20107 17.8989 8.8534 17.9479 8.5294 18.0714C8.20539 18.1948 7.91336 18.3897 7.675 18.6416C7.43665 18.8934 7.25808 19.1957 7.15257 19.526C7.04706 19.8563 7.01732 20.2061 7.06555 20.5495ZM43.7417 39.5024C43.9391 39.5024 44.1284 39.424 44.268 39.2844C44.4075 39.1448 44.486 38.9555 44.486 38.7581V34.4433C44.4848 34.3118 44.4493 34.183 44.3831 34.0695C44.3169 33.956 44.2222 33.8618 44.1084 33.7961L37.6362 30.15C37.5234 30.0836 37.3949 30.0486 37.264 30.0486C37.1331 30.0486 37.0046 30.0836 36.8919 30.15C36.7794 30.2136 36.6861 30.3062 36.6216 30.4181C36.5571 30.5301 36.5238 30.6573 36.5251 30.7864V41.5735C36.5251 41.7709 36.6035 41.9603 36.7431 42.0999C36.8827 42.2394 37.072 42.3178 37.2694 42.3178C37.4668 42.3178 37.6561 42.2394 37.7957 42.0999C37.9353 41.9603 38.0137 41.7709 38.0137 41.5735V32.0485L43.0189 34.864V38.7042C43.0189 38.9016 43.0973 39.0909 43.2369 39.2305C43.3765 39.3701 43.5658 39.4485 43.7632 39.4485L43.7417 39.5024ZM54.1188 42.2963H40.7536C40.6564 42.2948 40.5599 42.3128 40.4696 42.349C40.3794 42.3852 40.2972 42.439 40.228 42.5073C40.1587 42.5755 40.1037 42.6569 40.0662 42.7466C40.0286 42.8363 40.0093 42.9326 40.0093 43.0298V45.2627H27.4208C27.2234 45.2627 27.0341 45.3411 26.8945 45.4807C26.7549 45.6203 26.6765 45.8096 26.6765 46.007V47.7438H14.0772C13.8826 47.7438 13.696 47.821 13.5585 47.9586C13.4209 48.0961 13.3436 48.2827 13.3436 48.4773V50.57H0.74431C0.546907 50.57 0.357589 50.6484 0.218004 50.788C0.0784187 50.9275 0 51.1169 0 51.3143V54.1189C0.00283403 54.3145 0.0825022 54.501 0.221781 54.6383C0.36106 54.7755 0.548762 54.8525 0.74431 54.8524C0.939858 54.8525 1.12756 54.7755 1.26684 54.6383C1.40612 54.501 1.48578 54.3145 1.48862 54.1189V52.0586H13.3544V54.1189C13.3544 54.3135 13.4317 54.5 13.5693 54.6376C13.7068 54.7752 13.8934 54.8524 14.0879 54.8524C14.2835 54.8525 14.4712 54.7755 14.6105 54.6383C14.7497 54.501 14.8294 54.3145 14.8323 54.1189V49.2539H26.6981V54.1189C26.7009 54.3145 26.7806 54.501 26.9198 54.6383C27.0591 54.7755 27.2468 54.8525 27.4424 54.8524C27.6369 54.8524 27.8235 54.7752 27.961 54.6376C28.0986 54.5 28.1759 54.3135 28.1759 54.1189V46.7729H40.0417V54.1189C40.0417 54.3163 40.1201 54.5056 40.2597 54.6452C40.3993 54.7848 40.5886 54.8632 40.786 54.8632C40.9834 54.8632 41.1727 54.7848 41.3123 54.6452C41.4519 54.5056 41.5303 54.3163 41.5303 54.1189V43.7741H53.3961V54.0866C53.3961 54.284 53.4745 54.4733 53.6141 54.6129C53.7537 54.7524 53.943 54.8309 54.1404 54.8309C54.3378 54.8309 54.5271 54.7524 54.6667 54.6129C54.8063 54.4733 54.8847 54.284 54.8847 54.0866V43.019C54.8847 42.9218 54.8654 42.8255 54.8279 42.7358C54.7903 42.6461 54.7353 42.5647 54.6661 42.4965C54.5968 42.4282 54.5147 42.3744 54.4244 42.3382C54.3342 42.302 54.2376 42.2841 54.1404 42.2855L54.1188 42.2963Z"
                                        fill="#95A1A9" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_860_868">
                                        <rect width="54.82" height="54.82" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <br>
                            <br>

                            <p>

                                MISSION
                            </p>


                                </div>
                                    <div class="innerdiv">
                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>




                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>





                                        <p>
                                            What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                                        </p>

                                </div>



                                </div>
                            </div>

                            <div class="col-3 text-center">

                    <div  class="transparetdiv">

                        <div class="imges">
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.2592 14.7889C13.2204 14.7889 15.1011 14.0099 16.4879 12.6231C17.8746 11.2364 18.6537 9.35559 18.6537 7.39446C18.6537 5.43332 17.8746 3.5525 16.4879 2.16577C15.1011 0.77904 13.2204 0 11.2592 0C9.2989 0.0155346 7.42262 0.798222 6.03242 2.1804C4.64222 3.56257 3.84866 5.43427 3.82178 7.39446C3.8286 9.36094 4.61576 11.2443 6.0103 12.6308C7.40484 14.0173 9.29273 14.7935 11.2592 14.7889ZM29.7411 10.1255C29.5816 9.93987 29.355 9.8252 29.111 9.80668C28.867 9.78815 28.6256 9.86731 28.4399 10.0268C28.2543 10.1862 28.1396 10.4128 28.1211 10.6568C28.1026 10.9009 28.1817 11.1422 28.3412 11.3279L30.7201 14.119C30.8897 14.2992 31.0931 14.4442 31.3188 14.5456C31.5445 14.647 31.7879 14.703 32.0353 14.7101C32.2826 14.7173 32.5289 14.6756 32.7601 14.5875C32.9912 14.4993 33.2027 14.3664 33.3825 14.1964L33.5113 14.0675L38.7244 7.99565C38.8747 7.81938 38.9521 7.59246 38.9409 7.36109C38.9297 7.12973 38.8308 6.91131 38.6643 6.75034C38.5779 6.67301 38.4769 6.61394 38.3671 6.5767C38.2574 6.53946 38.1413 6.52482 38.0257 6.53364C37.9102 6.54247 37.7976 6.5746 37.6948 6.62807C37.592 6.68155 37.5011 6.75526 37.4275 6.8448L32.1114 12.9253L29.7411 10.1255ZM45.2772 4.86092C38.2091 -1.54591 28.8479 -1.59743 21.8399 4.86092C21.642 5.07313 21.5316 5.35228 21.5307 5.64245C22.7415 13.2866 26.8469 20.1719 32.996 24.8715C33.1591 24.9774 33.3512 25.0294 33.5454 25.0202C33.7396 25.0109 33.9259 24.9409 34.0781 24.82C40.2432 20.1584 44.3521 13.2805 45.5348 5.64245C45.5563 5.5011 45.5441 5.35671 45.4994 5.22093C45.4546 5.08515 45.3785 4.96181 45.2772 4.86092ZM33.5628 22.9563C28.2074 18.6817 24.6049 12.592 23.4373 5.83999C29.5779 0.472342 37.4791 0.523872 43.6798 5.83999C42.5053 12.5874 38.9078 18.6739 33.5628 22.9563ZM14.8319 15.5619C12.5347 16.4888 9.971 16.5072 7.66074 15.6134C3.4611 13.7498 0 18.9285 0 22.6987V29.0798C0 30.1705 0.566861 31.6562 3.15192 32.4464L5.05848 33.0647V42.5118C5.07423 43.3236 5.40782 44.0968 5.98755 44.6653C6.56728 45.2338 7.34687 45.5521 8.15882 45.552H14.2994C14.6987 45.552 15.094 45.4733 15.4629 45.3206C15.8317 45.1678 16.1669 44.9438 16.4492 44.6615C16.7315 44.3792 16.9554 44.0441 17.1082 43.6752C17.261 43.3063 17.3396 42.911 17.3396 42.5118V33.142L19.2463 32.4721C20.1051 32.1629 22.3981 31.3814 22.3981 29.1055V22.6987C22.3981 18.98 18.9628 13.7498 14.8061 15.5619H14.8319ZM20.629 29.0798C20.629 29.5865 20.4229 30.1705 18.7224 30.7373L17.3826 31.201V23.2569C17.3916 23.1385 17.3773 23.0195 17.3403 22.9066C17.3033 22.7938 17.2444 22.6893 17.1671 22.5992C17.0897 22.509 16.9954 22.435 16.8894 22.3814C16.7835 22.3277 16.668 22.2955 16.5495 22.2865C16.4311 22.2774 16.3121 22.2918 16.1992 22.3288C16.0864 22.3658 15.9819 22.4246 15.8918 22.502C15.8017 22.5794 15.7277 22.6737 15.674 22.7797C15.6203 22.8856 15.5881 23.0011 15.5791 23.1195C15.5705 23.1649 15.5705 23.2115 15.5791 23.2569V42.486C15.5725 42.8142 15.4392 43.1271 15.2071 43.3593C14.9749 43.5914 14.662 43.7247 14.3338 43.7313H8.19321C8.0267 43.7347 7.86112 43.7051 7.70609 43.6443C7.55105 43.5835 7.40963 43.4925 7.28988 43.3768C7.17014 43.261 7.07446 43.1227 7.0084 42.9698C6.94234 42.817 6.90721 42.6525 6.90497 42.486V23.2827C6.90838 23.0509 6.8232 22.8265 6.66684 22.6553C6.51048 22.4842 6.29472 22.3791 6.06355 22.3616C5.83238 22.344 5.60323 22.4154 5.42284 22.561C5.24246 22.7066 5.12441 22.9156 5.09282 23.1453V31.1753L3.75305 30.763C1.84647 30.1962 1.84649 29.3546 1.84649 29.1055V22.6987C1.84649 20.2682 4.11379 16.0342 6.99943 17.2709C9.75247 18.3918 12.8346 18.3918 15.5877 17.2709C18.4218 16.0342 20.6462 20.2682 20.6462 22.6987L20.629 29.0798ZM11.2936 1.78634C12.3666 1.78626 13.4169 2.09595 14.3183 2.67821C15.2197 3.26048 15.9339 4.09054 16.375 5.06876C16.8161 6.04698 16.9655 7.13177 16.8052 8.19282C16.6449 9.25386 16.1817 10.2461 15.4712 11.0503C14.7608 11.8545 13.8333 12.4365 12.8001 12.7265C11.7669 13.0165 10.672 13.0021 9.64683 12.6849C8.62166 12.3678 7.70987 11.7615 7.02087 10.9388C6.33188 10.1162 5.895 9.11208 5.76272 8.04717C7.07344 8.36156 8.44525 8.31084 9.72917 7.90053C11.0131 7.49022 12.1601 6.73598 13.0455 5.71974C13.1602 5.53378 13.2048 5.31309 13.1714 5.09719C13.1381 4.8813 13.0289 4.68434 12.8635 4.54166C12.6981 4.39898 12.4872 4.3199 12.2687 4.3186C12.0503 4.3173 11.8385 4.39389 11.6714 4.53459C10.9577 5.33406 10.031 5.9137 8.99977 6.20571C7.96859 6.49773 6.87555 6.49003 5.84859 6.18351C6.11688 4.94717 6.7997 3.83966 7.78377 3.04459C8.76784 2.24953 9.9941 1.81466 11.2592 1.81211L11.2936 1.78634Z" fill="#95A1A9"/>
                            </svg>
                            <br>
                            <br>

                            <p>

                                CORE VALUE
                            </p>


                                </div>
                        <div class="innerdiv">
                            <p>
                                What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                            </p>




                            <p>
                                What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                            </p>





                            <p>
                                What makes our Book the best? They are easy to understand and they’re updated with the latest guidelines.
                            </p>

                    </div>



                    </div>
                    </div>


                        </div>


                    </div>
                </div>
                <br />
            </div>
        </section>
       
    </div>
</template>

<script>


// import Foot from "../../components/Footer";
// import Topheader from "./components/topheader.vue"

export default {
    name: "AboutPage",
  
    data() {
        return {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            password_confirm: "",
            isLoading: false,
            feedback:false
        };
    },

    // computed: {
    //     ...mapGetters(["user"])
    // },
    methods: {


        snedtoadmin(){
            this.feedback = false

        },



        feeds(){
            this.feedback =! this.feedback ;
        }
    }
};
</script>

<style scoped>

.leftside {
    display: flex;
    padding-bottom: 20px;
}

button.backbutton {
    padding: 5px;
    border: 1px solid #d3d3d3;
    border-radius: 5px;
    cursor: pointer;
}

.transparetdivs {
    border: 1px solid #95a1a9;
    border-radius: 18px;
    padding: 40px 40px 30px 40px;
}

.transparetdiv {
    border: 1px solid #95a1a9;
    border-radius: 18px;
    padding: 30px 15px 15px 15px;
}
.innerdiv {
    padding: 25px 35px 25px 35px;
}


.innerdiv p {
    font-size: 16px;
    color: #95a1a9;
}


.form {
  display: flex;
  flex-direction: column;
  background: #606c88;
  background: -webkit-linear-gradient(to right, #95a1a9, #606c88);
  background: linear-gradient(to right, #95a1a9, #606c88);
  padding: 20px;
  border-radius: 10px;
  max-width: 350px;
  position: absolute;
    bottom: 25%
}

.title {
  font-size: 2rem;
  line-height: 2rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #fff;
}

.description {
  line-height: 1.5rem;
  font-size: 1rem;
  margin-top: 1rem;
  color: rgb(209 213 219);
}

.form div {
  display: flex;
  max-width: 28rem;
  margin-top: 1rem;
  column-gap: 0.5rem;
}

.form div input {
  outline: none;
  line-height: 1.5rem;
  font-size: 0.875rem;
  color: rgb(255 255 255 );
  padding: 0.5rem 0.875rem;
  background-color: rgb(255 255 255 / 0.05);
  border: 1px solid rgba(253, 253, 253, 0.363);
  border-radius: 0.375rem;
  flex: 1 1 auto;
}

.form div input::placeholder {
  color: rgb(216, 212, 212);
}

.form div input:focus {
  border: 1px solid rgb(57 170 225);
}

.form div button {
  color: #fff;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.625rem 0.875rem;
  background-color: rgb(57 170 225);
  border-radius: 0.375rem;
  border: none;
  outline: none;
}

.home-btn-box {
    padding-bottom: 20px;
    padding-top: 20px;
}

.home-btn-box button {
    height: 125px !important;
}

footer.footers {
    position: absolute;
    bottom: 0;
    width: 100%;
}




img.heads {
    width: 65%;
    border-radius: 50px;
    height: 100%;
    max-height: 53px;
    min-height: 53px;
    object-fit: cover;
}



.row.scale {
    width: 100%;
    margin: 80px 0px;
    /* height: 100vh; */
}

p.scalep {
    color: white;
    font-family: "helveticaneue";
    font-weight: bold;
    font-size: 30px;
    padding-top: 10px;
}

.colorcard {
    width: 100%;
    padding: 30px 10px 20px 10px;
    border-radius: 5px;
    box-shadow: 0px 4px 4px 0px #00000040;
}

.rowfooter {
    width: 100%;
    padding: 15px;
    border-top: 1px solid #95a1a9;
    padding-bottom: 10px;
    display: flex;
    align-content: center;
    align-items: center;
}

.Subscription-card-tital {
    width: 100%;
    padding: 20px 0px 0px 0px;
}

.Subscription-tital h2 {
    font-family: "helveticas";
}

.Login-logo {
    width: 18%;
    padding-bottom: 30px;
}

.Subscription-card-box {
    padding-top: 0px;
    padding-bottom: 30px;
}

.Subscription-card {
    border-radius: 50px;
}

.Subscription-card {
    width: 18%;
    border: 1px solid #95a1a9;

    height: 425px;
    padding: 18px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.Subscription-h2 {
    width: 9%;
    text-align: end;
}

.Subscription-cards {
    width: 18%;
    border: 1px solid #95a1a9;
    border-radius: 50px;
    height: 546px;
    padding: 50px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #95a1a9;
}

.Subscription-card-titals {
    width: 100%;
    padding: 40px 0px 0px 0px;
}

.Subscription-card-titals p {
    font-size: 24px;
    font-weight: 100;
    text-align: center;
    line-height: 30px;
    color: white;
    font-family: sans-serif;
}

.Subscription-card-titals h2 {
    font-size: 26px;
    font-weight: 600;
    text-align: center;
    line-height: 35px;
    color: white;
    font-family: sans-serif;
}

.Subscription-card-titals h3 {
    font-size: 50px;
    font-weight: 200 !important;
    text-align: center;
    line-height: 54px;
    color: white;
    font-family: ui-monospace;
}

.main-Subscription {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    padding-top: 0px !important;
}

.Subscription-cards button {
    background-color: #39aae1;
    border: none;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    font-family: sans-serif;
    padding: 16px 50px;
    border-radius: 8px;
}

.Subscription-card-img {
    width: 32%;
}

.dashboard_footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0px;
}


.home-btn-box button  svg path {
    fill: #95A1A9;
}

.home-btn-box button:hover svg path {
    fill: white;
}


.home-btn-box button:hover p {
    color: #fff;
}

.dashboard_call_btn button {
    height: 150px;
    box-shadow: 0px 4px 4px 0px #00000040;
}


@media screen and (max-width: 1600px) {

    .row.scale {
    width: 100%;
    margin: 55px 0px;
    /* height: 100vh; */
}
    .main-Subscription {
        height: 100%;
    }

    .Subscription-card-titals h2 {
        font-size: 20px;

        line-height: 27px;
    }

    .Subscription-cards {
        width: 23%;

        height: 420px;
        padding: 0px 0px;
    }

    .Subscription-card-titals h3 {
        font-size: 40px;

        line-height: 40px;
    }

    .Subscription-card-titals p {
        font-size: 20px;

        line-height: 20px;
    }

    .Subscription-cards button {
        font-size: 16px;

        padding: 10px 30px;
    }

    .Subscription-card {
        width: 23%;
        height: 310px;
    }
}

@media screen and (max-width: 1440px) {
    .home-btn-box {
        padding-bottom: 20px;
        padding-top: 0px;
    }

    /* .imagers{
        width: 20%;
    } */


    .colorcard{
    width: 100%;
    padding: 30px 10px 20px 10px;
    border-radius: 5px;
    box-shadow: 0px 4px 4px 0px #00000040;
}
}
</style>
